export type TemplatesNavigationState = {
  templatesBackPath: string;
};

export const DEFAULT_TEMPLATES_BACK_PATH = '/company-settings?tab=Templates';

export const getPathWithSearch = (pathname: string, search = ''): string =>
  search ? `${pathname}${search}` : pathname;

export const createTemplatesNavigationState = (
  templatesBackPath: string,
): TemplatesNavigationState => ({
  templatesBackPath,
});

export const hasTemplatesNavigationState = (
  state: unknown,
): state is TemplatesNavigationState =>
  Boolean(
    state &&
      typeof state === 'object' &&
      'templatesBackPath' in state &&
      typeof state.templatesBackPath === 'string' &&
      state.templatesBackPath,
  );

export const resolveTemplatesBackPath = (
  state: unknown,
  fallback = DEFAULT_TEMPLATES_BACK_PATH,
): string => {
  if (hasTemplatesNavigationState(state)) {
    return state.templatesBackPath;
  }

  return fallback;
};

export const parseTemplatesPath = (path: string) => {
  const [pathnamePart, searchPart] = path.split('?');
  const pathname = pathnamePart || DEFAULT_TEMPLATES_BACK_PATH;
  const search = searchPart ? `?${searchPart}` : '';

  return {
    pathname,
    search,
    searchParams: new URLSearchParams(searchPart ?? ''),
  };
};
